export default __webpack_public_path__ + "8168fbf1487a1f601b4fad72b260a88d.jpeg";